import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  Divider,
  Grid,
  Menu,
  MenuItem,
  Typography,
  Avatar,
  Tooltip,
} from '@mui/material';
import { styled } from '@mui/material/styles';

//Icons
import AccountCircle from '@mui/icons-material/AccountCircle';
import PersonIcon from '@mui/icons-material/Person';
import EditIcon from '@mui/icons-material/Edit';
import LogoutIcon from '@mui/icons-material/Logout';
import InfoIcon from '@mui/icons-material/Info';

// Styled components
const ColorButton = styled(Button)(({ theme }) => ({
  color: 'primary',
  height: theme.mixins.toolbar.minHeight,
}));

const StyledMenu = styled(props => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    backgroundColor: '#1a242d',
    borderRadius: 3,
    marginTop: theme.spacing(1),
    minWidth: 300,
    color: theme.palette.mode === 'light' ? 'white' : 'black',
  },
}));

const styles = {
  icon: {
    color: 'white',
  },
  text: {
    fontSize: 14,
    marginLeft: 12,
  },
};

function MyMenu(props) {
  const { userInfo, logOut, userCosmetics, getUserCosmetics } = props;
  const REACT_APP_AUTH_BASE_URL = process.env.REACT_APP_AUTH_BASE_URL
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const audioRef = useRef({});

  useEffect(() => {
    if (getUserCosmetics && (!userCosmetics || userCosmetics.length === 0)) {
    getUserCosmetics();
    }
  }, []);

  useEffect(() => {
    if (!userCosmetics) return;
    userCosmetics.forEach(cosmetic => {
      if (cosmetic.signed_sound_url && !audioRef.current[cosmetic.cosmetic_id]) {
        const audio = new Audio(cosmetic.signed_sound_url);
        audio.preload = 'auto';
        audioRef.current[cosmetic.cosmetic_id] = audio;
      }
    });
  }, [userCosmetics]);

  const handleOpenMenu = event => {
    setOpen(true);
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(false);
  };

  const handleCosmeticClick = (cosmetic) => {
    const audio = audioRef.current[cosmetic.cosmetic_id];
    if (audio) {
      audio.currentTime = 0;
      audio.play();
    }
  };

  const handleProfileNavigation = () => {
    window.location.href = `${REACT_APP_AUTH_BASE_URL}/profile?tenant=${userInfo.firebase.tenant}&redirect=${window.location.href}`;
  };

  return (
    <Grid sx={{ display: 'flex', alignItems: 'center' }}>
      {userCosmetics && userCosmetics.length > 0 && (
        <Grid sx={{ display: 'flex', flexDirection: 'row-reverse', alignItems: 'center', marginRight: 1 }}>
          {userCosmetics.map(cosmetic => (
            <Tooltip
              key={cosmetic.cosmetic_id}
              placement="bottom"
              title={<span style={{ textAlign: 'center', display: 'block' }}>{cosmetic.description || 'Reward'}</span>}
            >
              <img
                src={cosmetic.signed_thumbnail_url || cosmetic.signed_image_url}
                alt={cosmetic.description || 'Reward'}
                style={{ width: 50, height: 50, marginLeft: 4, borderRadius: '0%', objectFit: 'contain', cursor: cosmetic.signed_sound_url ? 'pointer' : 'default' }}
                onClick={() => handleCosmeticClick(cosmetic)}
              />
            </Tooltip>
          ))}
        </Grid>
      )}
      <ColorButton onClick={handleOpenMenu}>
        {(
          <Avatar style={styles.icon} fontSize="large" src={userInfo.picture} />
        ) || <AccountCircle style={styles.icon} fontSize="large" />}
      </ColorButton>

      <StyledMenu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseMenu}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}>
        <MenuItem onClick={handleCloseMenu}>
          <PersonIcon style={styles.icon} />
          <Typography style={styles.text}>{userInfo.name}</Typography>
        </MenuItem>
        <MenuItem onClick={handleProfileNavigation}>
          <EditIcon style={styles.icon} />
          <Typography style={styles.text}>Edit profile</Typography>
        </MenuItem>

        <MenuItem
          onClick={() =>
            window.location.replace(
              'https://zippedi.gitbook.io/project-management-app/',
            )
          }>
          <InfoIcon style={styles.icon} />
          <Typography style={styles.text}>About</Typography>
        </MenuItem>

        <Divider variant="middle" style={{ background: 'white' }} />

        <MenuItem onClick={logOut}>
          <LogoutIcon style={styles.icon} />
          <Typography style={styles.text}>Logout</Typography>
        </MenuItem>
      </StyledMenu>
    </Grid>
  );
}

export default MyMenu;
